import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Text } from 'src/Components'
import Section from '../Section'
import calendarIcon from './calendar.svg'
import craneIcon from './crane.svg'
import houseIcon from './house.svg'
import waveIcon from './wave.svg'
import styles from './ThingsToNote.module.scss'

const propTypes = {
  listing: PropTypes.object,
  className: PropTypes.string,
}

const defaultProps = {
  className: '',
}

const ThingsToNote = ({ listing, className }) => (
  <Section className={className}>
    <Section.Heading>
      <FormattedMessage
        id='HomeSearch.listingDetails.thingsToNote'
        defaultMessage='Things To Note'
      />
    </Section.Heading>
    <Section.Body className={styles.thingsToNote}>
      <div className={styles.item}>
        <img src={calendarIcon} alt='calendar icon' />
        <Text element='p' variant='neutralCool' variantCount='900' align='left'>
          Built in {listing.yearBuilt}
        </Text>
      </div>
      <div className={styles.item}>
        <img src={houseIcon} alt='house icon' />
        <Text element='p' variant='neutralCool' variantCount='900' align='left'>
          {listing.propertyType}
        </Text>
      </div>
      {listing.is?.isWaterfront && (
        <div className={styles.item}>
          <img src={waveIcon} alt='wave icon' />
          <Text
            element='p'
            variant='neutralCool'
            variantCount='900'
            align='left'
          >
            Waterfront
          </Text>
        </div>
      )}
      {listing.is?.isNewConstruction && (
        <div className={styles.item}>
          <img src={craneIcon} alt='crane icon' />
          <Text
            element='p'
            variant='neutralCool'
            variantCount='900'
            align='left'
          >
            New Construction
          </Text>
        </div>
      )}
    </Section.Body>
  </Section>
)

ThingsToNote.propTypes = propTypes
ThingsToNote.defaultProps = defaultProps

export default ThingsToNote
